import { Component, OnInit, AfterViewInit, Inject, ViewChild, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';

import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';

import { SelectionModel } from '@angular/cdk/collections';



import { IZipCode, ZipCodeApiService } from '@ebb-v2/ebb-integration';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';

@Component({
  selector: 'ebb-portal-dialog-zipcode',
  templateUrl: './dialog-zipcode.component.html'
})
export class DialogZipcodeComponent implements OnInit, AfterViewInit {
  public title = 'Add ZIP Code';

  public listZip: IZipCode[] = [];
  public listZipSelected: IZipCode[] = [];
  public listSearch: IZipCode[] = [];

  public dataSourceTable = new MatTableDataSource<IZipCode>([]);
  public selection = new SelectionModel<IZipCode>(true, []);
  public dataResultsLength = 0;
  public displayedColumns: string[] = ['checkbox', 'zipCode', 'city'];
  public tablePageSizeOptions: number[] = [7];

  public formSearch: FormGroup;

  public waitForListingToShow = true;
  public noSearchResults = false;
 
  @ViewChild(MatPaginator) dataPaginator: MatPaginator;

  constructor(
    public readonly dialogRef: MatDialogRef<DialogZipcodeComponent>,
    public readonly apiZipCode: ZipCodeApiService,
    @Inject(MAT_DIALOG_DATA) public data,
    private readonly fb: FormBuilder,
    private readonly cdRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.dataSourceTable.paginator = this.dataPaginator;
    this.InitializeForms();
    this.loadData();
  }

  ngAfterViewInit() {
    this.dataSourceTable.paginator = this.dataPaginator;
    //this.listZipSelected = null;
  }


  private InitializeForms(): void {
    // Permit info
    this.formSearch = this.fb.group({
      searchPhrase: ''
    });

    this.formSearch.get('searchPhrase').valueChanges
      .subscribe(phrase => this.searchZipCodeListByPhrase(phrase));
  }

  private loadData(): void {
    this.apiZipCode
    .get()
    .subscribe(
      data => {
        this.listZip = data;
        this.pageDirectoryData(this.listZip);
      },
      error => console.warn(`${JSON.stringify(error)}`),
    );
  }

  private pageDirectoryData(paginateList: IZipCode[]): void {
    if ( Array.isArray(paginateList) && paginateList.length > 0 )
    {
      this.noSearchResults = false;
      this.dataResultsLength = paginateList.length;
      this.dataSourceTable.data = paginateList;
    }
    else {
      this.noSearchResults = true;
    }
    this.cdRef.markForCheck();
    this.waitForListingToShow = false;
  }
  
  public checkboxLabel(row?: IZipCode): string {
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.name}`;
  }

  private searchZipCodeListByPhrase(phrase: string): void {
    if (phrase.length > 0) {
      this.listSearch = this.listZip.filter((code: IZipCode) =>
        (
          code.name.toLowerCase().startsWith(phrase.toLowerCase()) !== false ||
          code.county.toLowerCase().startsWith(phrase.toLowerCase()) !== false 
        )
      );
      this.pageDirectoryData(this.listSearch);
    }
    else {
      this.pageDirectoryData(this.listZip);
    }
  }

  onClickCancel(): void {
    this.dialogRef.close();
  }

  onClickSave(): void {
    for(let i = 0;  i < this.dataSourceTable.data.length; i++) {
      if (this.selection.isSelected(this.dataSourceTable.data[i])) {
        this.listZipSelected.push(this.dataSourceTable.data[i]);
      }
    }
    this.dialogRef.close(this.listZipSelected);
  }

}
